import { bool, func, shape } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import Iframe from 'ravenjs/lib/Iframe';
import { get } from 'ravenjs/utils/lodash';
import { renderCheck } from 'ravenjs/utils/viewport';

import { DEFAULT_COLORS } from 'constants/colors';
import { MODALS } from 'constants/modals';
import { COMPENSATION_TOOL } from 'constants/tools';
import { actions as uiActions, selectors as uiSelectors } from 'modules/ui';
import { SALARY_URL } from 'constants/api';

import Modal from '../Modal';

const ContentWrapper = styled.div`
    ${({ theme }) => theme.media.down('md')`
        height: 100%;
    `};
    ${({ theme }) => theme.media.up('md')`
        height: 706px;
        max-width: 972px;
    `};
`;

const SalaryCompareModal = props => {
    const { closeModal, modal } = props;
    const open = get(modal, 'open', false);

    const onClickCloseIcon = () => {
        closeModal(MODALS.SALARY_COMPARE);
    };

    const renderContent = () => {
        return (
            <ContentWrapper>
                <Iframe
                    id="gnSalaryCompareIframe"
                    src={SALARY_URL}
                    sandbox="allow-forms allow-same-origin allow-popups allow-scripts"
                />
            </ContentWrapper>
        );
    };

    return (
        <Modal
            hideActions
            id={MODALS.SALARY_COMPARE}
            actions={[]}
            content={renderContent()}
            onClickCloseIcon={onClickCloseIcon}
            open={open}
            title={COMPENSATION_TOOL}
            ModalProps={{
                ContentProps: {
                    style: {
                        height: '706px',
                        maxWidth: '972px',
                    },
                },
            }}
            modalBodyProps={{
                backgroundColor: DEFAULT_COLORS.WHITE,
                borderBottomLeftRadius: '4px',
                borderBottomRightRadius: '4px',
                height: renderCheck('md', 'less') ? '706px' : undefined,
                overflow: renderCheck('md', 'less') ? undefined : 'hidden',
                paddingTop: '0',
            }}
            modalHeaderProps={{
                border: 'none',
                fontSize: '1.75rem',
                paddingBottom: '1.5rem',
                paddingTop: '1rem',
            }}
        />
    );
};

SalaryCompareModal.propTypes = {
    closeModal: func.isRequired,
    modal: shape({
        open: bool,
    }).isRequired,
};

const mapDispatchToProps = {
    closeModal: uiActions.closeModal,
};

const mapStateToProps = () =>
    createStructuredSelector({
        modal: uiSelectors.getModalById(MODALS.SALARY_COMPARE),
    });

export { SalaryCompareModal as SalaryCompareModalUnwrapped };
export default connect(mapStateToProps, mapDispatchToProps)(SalaryCompareModal);
